import React from "react";

export default function Message() {
  return (
    <div className="min-h-screen bg-admin_black flex flex-col items-center justify-center">
      <h1 className="text-white text-3xl font-semibold">Session TimeOut.</h1>

    </div>
  );
}
